import React from 'react';

const RulesPage = () => {
  return <div>RulesPage</div>;
};

export default RulesPage;
